<template>
    <div id="product-offer">
        <div class="row">
            <div class="product-offer">
                <div class="product-offer--filter">
                    <ProductsFilters :author_id="author_id" :category_id="category_id" :filterData="filterData" @filter="updateFilter( $event )" />
                </div>

                <div class="product-offer--navigation" ref="navigation">
                    <div class="h-navigation">
                        <ul class="h-navigation--list">
                            <li class="h-navigation--list--item" :class="{'item-active' : filterData.sort_column === 'best-seller'}">
                                <span @click="filterData.sort_by = 'DESC', filterData.sort_column = 'best-seller'">Najpredávanejšie</span>
                            </li>
                            <li class="h-navigation--list--item" :class="{'item-active' : filterData.sort_column === 'created_at'}">
                                <span @click="filterData.sort_by = 'DESC', filterData.sort_column = 'created_at'">Najnovšie</span>
                            </li>
                            <li class="h-navigation--list--item" :class="{'item-active' : filterData.sort_column === 'unified_discount_value'}">
                                <span @click="filterData.sort_by = 'DESC', filterData.sort_column = 'unified_discount_value'">Najväčšia zľava</span>
                            </li>
                            <li class="h-navigation--list--item" :class="{'item-active' : filterData.sort_column === 'final_price' && filterData.sort_by === 'ASC' }">
                                <span @click="filterData.sort_by = 'ASC', filterData.sort_column = 'final_price'">Najlacnejšie</span>
                            </li>
                            <li class="h-navigation--list--item" :class="{'item-active' : filterData.sort_column === 'final_price' && filterData.sort_by === 'DESC'}">
                                <span @click="filterData.sort_by = 'DESC', filterData.sort_column = 'final_price'">Najdrahšie</span>
                            </li>
                        </ul>

                        <div v-if="activeFiltersCount" class="h-navigation--active-filters">
                            <span v-if="activeFiltersCount" class="btn btn-text-action-black" @click="deleteFilters()">
                                Zrušiť filtre ({{ activeFiltersCount }})
                            </span>

                            <span class="filter-btn"  v-for="(item, index) in activeFilters" :key="index" @click="removeFilter( item )">
                                {{ item.title }}
                            </span>
                        </div>
                    </div>

                    <div class="m-navigation">
                        <div class="m-navigation--col">
                            Zoradiť: <span class="arrow-down">Najpredávanejšie</span>
                        </div>

                        <div class="m-navigation--col">
                            <span>Filtrovať</span>
                        </div>
                    </div>
                </div>

                <div class="product-offer--list" >
                    <div class="products-listing">
                        <ProductSkeleton v-if="loading" v-for="n in 5" :key="'skeleton-' + n" />
                        <ProductListingBox v-if="!loading" v-for="(product, index) in object.data" :key="product.id" :product="product" :shopOptions="shopOptions" :user_id="user_id" :index="index" />
                    </div>

                    <div v-if="object && object.last_page !== 1" class="product-offer--pagination">
                        <div class="pagination">
                            <div
                                class="pagination--item"
                                v-for="(link, index) in object.links"
                                :key="index"
                            >
                                <span
                                    v-if="link.label === 'pagination.previous' && object.current_page !== 1"
                                    class="btn btn-default btn-icon-right btn-padding-medium"
                                    @click="filterData.page = object.current_page - 1"
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 4L6 8L10 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Späť
                                </span>

                                <span
                                    v-if="!isNaN(link.label)"
                                    class="btn btn-default btn-padding-medium btn-page"
                                    :class="{'btn-page-active' : link.active}"
                                    @click="filterData.page = parseInt(link.label)"
                                >
                                    {{ link.label }}
                                </span>

                                <div v-if="link.label === '...'" class="pagination--item">
                                    <span>...</span>
                                </div>

                                <span
                                    v-if="link.label === 'pagination.next' && object.current_page !== object.last_page"
                                    class="btn btn-default btn-icon-right btn-padding-medium"
                                    @click="filterData.page = object.current_page + 1"
                                >
                                    Ďalšie
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import ProductListingBox from '../product/ProductListingBox'
    import ProductsFilters from './ProductsFilters'
    import ProductSkeleton from './ProductSkeleton'

    export default {
        components: {
            ProductListingBox,
            ProductsFilters,
            ProductSkeleton
        },
        props: {
            shopOptions: {
                type: Object
            },
            author_id: {
                type: Number
            },
            category_id: {
                type: Number
            },
            user_id: {
                type: Number
            }
        },
        data() {
            return {
                loading: true,
                object: null,
                filterData: {
                    page: 1,
                    authors: [],
                    categories: [],
                    product_states: [],
                    in_stock: [],
                    publishing_houses: [],
                    sort_column: 'created_at',
                    sort_by: 'DESC'
                },
            }
        },
        created() {
            const fullUrl = new URL( window.location.href )

            const params = new URLSearchParams( fullUrl.search )

            if ( !params.size ) return this.loadData()

            params.forEach(( slug, type ) => {

                if ( type === 'order' ) return this.filterData.sort_column = slug

                axios.get(`/api/shop/search/filter/${type}/${slug}`)
                .then( response => {
                    let item = response.data.item
                    let prefix = type.replace('-', '_')

                    item.filter = prefix

                    this.filterData[ prefix ].push( item )
                }).catch( errors => {})
            })
        },
        computed: {
            activeFiltersCount() {
                return this.filter.authors.length
                    + this.filter.categories.length
                    + this.filter.product_states.length
                    + this.filter.in_stock.length
                    + this.filter.publishing_houses.length
            },
            activeFilters() {
                return [
                    ...this.filterData.authors,
                    ...this.filterData.categories,
                    ...this.filterData.product_states,
                    ...this.filterData.in_stock,
                    ...this.filterData.publishing_houses
                ]
            },
            filter() {
                return {
                    page: this.filterData.page,
                    per_page: 20,
                    author: this.author_id,
                    authors: this.filterData.authors.map( item => item.id ),
                    category: this.category_id,
                    categories: this.filterData.categories.map( item => item.id ),
                    product_states: this.filterData.product_states.map( item => item.id ),
                    in_stock: this.filterData.in_stock.map( item => item.id ),
                    publishing_houses: this.filterData.publishing_houses.map( item => item.id ),
                    sort_column: this.filterData.sort_column,
                    sort_by: this.filterData.sort_by
                }
            }
        },
        methods: {
            loadData() {
                this.loading = true

                axios.post('/api/shop/product/offer-list', { filter: this.filter })
                .then( response => {
                    this.object = response.data.object
                    this.loading = false
                }).catch( errors => {
                    this.loading = false
                })
            },
            updateFilter( item ) {
                this.filterData[ item.filter ].includes( item )
                    ? this.filterData[ item.filter ] = this.filterData[ item.filter ].filter( value => value != item )
                    : this.filterData[ item.filter ].push( item )
            },
            removeFilter( item ) {
                this.filterData[ item.filter ] = this.filterData[ item.filter ].filter( value => value != item )
            },
            deleteFilters() {
                Object.assign( this.filterData, {
                    authors: [],
                    categories: [],
                    product_states: [],
                    in_stock: [],
                    publishing_houses: []
                })
            },
            scrollToNavigation() {
                this.$nextTick(() => {
                    if (this.$refs.navigation) {
                        this.$refs.navigation.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                });
            }
        },
        watch: {
            'filter': {
                handler: function () {
                    this.loadData();
                    this.scrollToNavigation();
                },
                deep: true
            },
            'filterData.page': function () {
                this.loadData();
                this.scrollToNavigation();
            }
        }
    }
</script>
